import { Colors } from '../Colors';
import { remInPx } from '../Utils';

const defaults = {
    dropdown: {
        padding: 0,
    }
};

const help = {
    dropdown: {
        backgroundColor: Colors.mystery,
        color: Colors.white,
        cursor: 'pointer',
    }
};

export default {
    defaultProps: {
        shadow: 'lg',
        radius: remInPx(.5),
    },
    styles: (_, { variant }) => {
        if (variant === 'help') {
            return help;
        }
        return defaults;
    },
};
